import React, { Component } from 'react'
import isEmpty from "lodash/isEmpty";

// Components
import ProductSearch from "../products/product-search/ProductSearch";
import { REACT_APP_RESOURCE_URL } from '../../../shared/vars'

class AdminFeaturedProductsItem extends Component {
    render() {
        const { index, featuredProducts } = this.props;

        return (
            <div className="fp-admin-box">
                <ProductSearch
                    currentlySelected={!isEmpty(featuredProducts) ? new Array(featuredProducts) : []}
                    updateHandler={selections => this.props.handleProductSelect(selections, index)}
                    ignoreVariants={true}
                    disabled={!!featuredProducts && !isEmpty(featuredProducts)}
                />
                <div className="selected-item-wrapper">
                    {!!featuredProducts && !isEmpty(featuredProducts) &&
                        <div className="selected-item">
                            <div className="txt">{featuredProducts.title}</div>
                            <input type="hidden" name="buy_products[]" value={featuredProducts.id} />
                            <span className="icon-cross delete-category" onClick={() => { this.props.handleProductDelete(index)}}/>
                        </div>
                    }
                    {isEmpty(featuredProducts) && <div className="fp-admin-notification">No product selected</div>}
                </div>
                {!!featuredProducts && featuredProducts.src !== undefined &&
                    <div className="fp-admin-img-box"><img src={REACT_APP_RESOURCE_URL + 'images/products/1/' + featuredProducts.src} alt={featuredProducts.title}></img></div>
                }
            </div>
        )
    }
}


export default AdminFeaturedProductsItem;


// WEBPACK FOOTER //
// ./src/components/admin/products/AdminFeaturedProductsItem.js